import { render } from "./fastWestStoredModel.vue?vue&type=template&id=3528e78d"
import script from "./fastWestStoredModel.vue?vue&type=script&lang=js"
export * from "./fastWestStoredModel.vue?vue&type=script&lang=js"

import "./fastWestStoredModel.vue?vue&type=style&index=0&id=3528e78d&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__